import React from 'react';
import { Languages } from '@wix/wix-ui-icons-common';
import { Box } from '@wix/design-system';
import { st, classes } from './avatar.st.css';
export const SiteVisitorsIcon = (props) => {
    return (React.createElement(Box, { className: st(classes.avatarWrapper), color: props.color, backgroundColor: props.backgroundColor },
        React.createElement(Languages, { className: st(classes.avatar) })));
};
//# sourceMappingURL=SiteVisitorsIcon.js.map